module.exports = __webpack_public_path__ + "img/background01.24398eaf.jpg";